export const  GET_TEAM_REQUEST='teamReducer/GET_TEAM_REQUEST';
export const  GET_TEAM_SUCCESS='teamReducer/GET_TEAM_SUCCESS';
export const  GET_TEAM_FAILED='teamReducer/GET_TEAM_FAILED';